import Vue from "vue";
import Router from "vue-router";

const Inicio = () => import("@/views/Web/Home");
const Landing = () => import("@/views/Web/Landing");
const UserInternal = () => import("@/views/Web/UserInternal");
const We = () => import("@/views/Web/We");
const CommerceInternal = () => import("@/views/Web/CommerceInternal");
const InicioSesion = () => import("@/views/Web/Inicio");
const Contacto = () => import("@/views/Web/Contacto");

const Terms = () => import("@/views/Web/Terms");
const Privacy = () => import("@/views/Web/Privacy");
const Cookies = () => import("@/views/Web/Cookies");
const Fqa = () => import("@/views/Web/Fqa");
const Protection = () => import("@/views/Web/Protection");
const Claim = () => import("@/views/Web/Claim");
const PrivacyPolicy = () => import("@/views/Web/PrivacyPolicy");

const NewPassword = () => import("@/views/Web/NewPassword");

Vue.use(Router);

function configRoutes() {
  return [
    {
      path: "/",
      name: "Inicio",
      redirect: "/home",
      component: Inicio,
      children: [
        {
          path: "/home",
          name: "home",
          component: Landing,
        },
        {
          path: "/usuario",
          name: "interna-usuario",
          component: UserInternal,
        },
        {
          path: "/negocio",
          name: "interna-comercio",
          component: CommerceInternal,
        },
        {
          path: "/nosotros",
          name: "nosotros",
          component: We,
        },
        {
          path: "/contacto",
          name: "contacto",
          component: Contacto,
        },
        {
          path: "/condiciones",
          name: "terms",
          component: Terms,
        },
        {
          path: "/privacidad",
          name: "privacy",
          component: Privacy,
        },
        {
          path: "/politica-privacidad",
          name: "privacy-policy",
          component: PrivacyPolicy,
        },
        {
          path: "/cookies",
          name: "cookies",
          component: Cookies,
        },
        {
          path: "/fqa",
          name: "fqa",
          component: Fqa,
        },
        {
          path: "/proteccion",
          name: "protection",
          component: Protection,
        },
        {
          path: "/claim",
          name: "claim",
          component: Claim,
        },
      ],
    },
    {
      path: "/sesion",
      name: "inicio-sesion",
      component: InicioSesion,
    },
    {
      path: "/new-password",
      name: "new-password",
      component: NewPassword,
    },
  ];
}

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: configRoutes(),
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});
